  // PRODUCT STICKY
  $( document ).ready(function() {

    window.onscroll = changePos;

    $(window).resize(function() {
        changePos();      
    });
    
    function checkVisible( elm, eval ) {
    	if(elm){
          eval = eval || "visible";
          var vpH = $(window).height(), // Viewport Height
              st = $(window).scrollTop(), // Scroll Top
              y = $(elm).offset().top,
              elementHeight = $(elm).height();
          if (eval == "visible") return ((y < (vpH + st)) && (y > (st - elementHeight)));
          if (eval == "above") return ((y < (vpH + st)));
        }
    }  

    function checkAbove( elm, eval ) {
    	if(elm){
          eval = eval || "visible";
          var vpH = $(window).height(), // Viewport Height
              st = $(window).scrollTop(), // Scroll Top
              y = $(elm).offset().top,
              elementHeight = $(elm).height();
          if (eval == "above") return ((y < (vpH + st)));
        }
    }   

  	function changePos() {   
      var navheight = $("#shopify-section-announcement").height();
      //var navheight = 0;
      if (window.pageYOffset > navheight) {
        $("#product-sticky").addClass("fixed");
      } else {
        $("#product-sticky").removeClass("fixed");
      }
      
      var elm = document.querySelector('#add-to-cart-message');
      if(elm){
        var position = elm.getBoundingClientRect();
        //var info = $("#MainForm__AddToCart");
        var info = $("#add-to-cart-message");
        if( window.pageYOffset < navheight){
          $.when($("#product-sticky").fadeIn(250)).done(function() {
            $("#product-sticky").removeClass("fixed");
            //$("#product-sticky").removeClass("hidden");
          });

        } else {
          if (checkVisible(info)) {

            if ($(window).width() > 1007){
              $.when($("#product-sticky").fadeOut(250)).done(function() {
              	$("#product-sticky").removeClass("fixed");
              });
            } else {
              //$("#product-sticky").addClass("hidden");
              $("#product-sticky").fadeOut(250);
            }
          } else {
            if (checkAbove(info)) {
            } else {
              
              //$("#product-sticky").removeClass("hidden");
              $("#product-sticky").fadeIn(250);
            }
          }
        }

      }
    }

    
    $(".PageContainer").on("click","#product-sticky-button", function(){
    	if ($(window).width() > 1007){
          $([document.documentElement, document.body]).animate({
            scrollTop: $("#sex-selector").offset().top
          }, 500);
        } else {      
          $([document.documentElement, document.body]).animate({
            scrollTop: $(".shoe-width-note").offset().top
          }, 500);
        }
    });
    $(".PageContainer").on("click","#product-sticky-button-gift", function(){
    	if ($(window).width() > 1007){
          $([document.documentElement, document.body]).animate({
            scrollTop: $("#sex-selector").offset().top - 00
          }, 500);
        } else {      
          $([document.documentElement, document.body]).animate({
            scrollTop: $("#sex-selector").offset().top - 100
          }, 500);
        }
    });    
  });

  $( ".Product__Info" ).on("click",".sex-text",function () {
    
        var sex = $(this).attr("data-sex");
        var href = window.location.pathname;
    	var title = $(this).attr("data-product");
                           
    	// remove variant
        var n = href.indexOf('?');
        href = href.substring(0, n != -1 ? n : href.length);
		var pagetitle = $(document).prop('title');

        if(href.indexOf('womens') !== -1){
          if(sex == 'mens'){
            href= href.replace("womens", "mens");
            pagetitle = pagetitle.replace("Women's", "Men's");
			$(document).prop('title', pagetitle);

            breadcrumbs = $("#product-breadcrumbs").html().replaceAll("women", "men").replaceAll("Women", "Men");
            $("#product-breadcrumbs").html(breadcrumbs)
            
    		$("#product-sticky").addClass("product-sticky-men");
    		$("#product-sticky").removeClass("product-sticky-women");
            $("#product-sticky-sex").html("Men's");
            $("#womens-size-chart").addClass("hide");
            $("#mens-size-chart").removeClass("hide");
          }
        } else {
          if(sex == 'womens'){
            href= href.replace("mens", "womens");
            pagetitle = pagetitle.replace("Men's", "Women's");
			$(document).prop('title', pagetitle);
            
            breadcrumbs = $("#product-breadcrumbs").html().replaceAll("men", "women").replaceAll("Men", "Women");
            $("#product-breadcrumbs").html(breadcrumbs)
            
    		$("#product-sticky").addClass("product-sticky-women");
    		$("#product-sticky").removeClass("product-sticky-men");
            $("#product-sticky-sex").html("Women's");
            $("#womens-size-chart").removeClass("hide");
            $("#mens-size-chart").addClass("hide");
          }
        }

    	// MOVE/HIDE BACK IN STOCK FORM
        $("#mobile-product-description-content").show();
        var load = href+" #product-info > *";
        $("#product-info").load(load, function(){ 
          
          // UPDATE URL
          window.history.pushState('Product', title, href);
          // UPDATE YOTPO
          //var api = new Yotpo.API(yotpo);
          //api.refreshWidgets();


          // UPDATE JS
          var src = "//goclove.com/cdn/shop/t/808/assets/theme.js?v=16078187783052021631745867513";
          $('script[src="' + src + '"]').remove();
          $('<script>').attr('src', src).appendTo('head');
          
          //$("#product-info").css("height","auto");
          //$("#product-info").css("width","auto");
    	  //$("#product-info-content").fadeIn();
          
          // UNDO-MOVE/HIDE BACK IN STOCK FORM
          //$("#back-in-stock").insertAfter("#product-info .ProductForm");
          //$("#back-in-stock").show();
          
          // UPDATE AFFIRM
          if (typeof affirm !== 'undefined') {
            affirm.ui.refresh();
          }  

       	});

        var headerheight = $("#product-mobile-header").height();
        $("#product-mobile-header").css("height", headerheight);
    	var load = href+" #product-mobile-header > *";
        $("#product-mobile-header").fadeTo(0);
    	$("#product-mobile-header").empty();
       	$("#product-mobile-header").load(load, function(){
          $("#product-mobile-header").css("height", "auto");
          $("#product-mobile-header").fadeTo(1);
        });

        /*
    	var load = href+" #product-sticky > *";
    	$("#product-sticky").empty();
       	$("#product-sticky").load(load, function(){});
        */
        // RELOAD STICKY
    	var load = href+" #header-b #product-sticky > *";
        $("#header-b #product-sticky").empty();
       	$("#header-b #product-sticky").load(load, function(){});
    	var load = href+" #header-e #product-sticky > *";
        $("#header-e #product-sticky").empty();
       	$("#header-e #product-sticky").load(load, function(){});

        /*
    	var load = href+" #product-mobile-header [data-oke-reviews-product-listing-rating] > *";
    	$("#product-mobile-header [data-oke-reviews-product-listing-rating]").empty();
       	$("#product-mobile-header [data-oke-reviews-product-listing-rating]").load(load, function(){});

    	var load = href+" .okeReviews-mobile-widget [data-oke-reviews-widget] > *";
    	$(".okeReviews-mobile-widget [data-oke-reviews-widget]").empty();
       	$(".okeReviews-mobile-widget [data-oke-reviews-widget]").load(load, function(){});

    	var load = href+" .okeReviews-desktop-widget [data-oke-reviews-widget] > *";
    	$(".okeReviews-desktop-widget [data-oke-reviews-widget]").empty();
       	$(".okeReviews-desktop-widget [data-oke-reviews-widget]").load(load, function(){});
        */
    
        /* IT LOOKS LIKE THIS STOP WORKING WHEN OKENDO WAS ADDED */
        /*
    	var load = href+" #yotpo-stars-container > *";
    	$("#yotpo-stars-container").empty();
       	$("#yotpo-stars-container").load(load, function(){});
        */

    	$("#yotpo-container-desktop").empty();
    	var load = href+" #yotpo-container-desktop > *";
       	$("#yotpo-container-desktop").load(load, function(){  
          // UPDATE YOTPO
          //resetYotpo();
       	});
    	$("#yotpo-container-mobile").empty();
    	var load = href+" #yotpo-container-mobile > *";
       	$("#yotpo-container-mobile").load(load, function(){  
          // UPDATE YOTPO
          resetYotpo();
       	});
  });


// RESET YOTPO
function resetYotpo(){
  if($('.yotpo-widget-instance').length == 0) {
  	setTimeout(resetYotpo, 150);
  } else {
    yotpoWidgetsContainer.initWidgets();
    resizeYotpo();
    moveYotpo();
  }
}

// RESIZE YOTPO
function resizeYotpo(){
  //if($('#yotpo-reviews-main-widget').length == 0) {
  	//setTimeout(resizeYotpo, 150);
  //} else {
    if ($(window).width() > 1400) { 
      //alert(1);
      $("#yotpo-reviews-main-widget").removeClass("yotpo-display-s");
      $("#yotpo-reviews-main-widget").removeClass("yotpo-display-m");
      $("#yotpo-reviews-main-widget").addClass("yotpo-display-l");
    } else {
      $("#yotpo-reviews-main-widget").addClass("yotpo-display-s");
      $("#yotpo-reviews-main-widget").removeClass("yotpo-display-m");
      $("#yotpo-reviews-main-widget").removeClass("yotpo-display-l");
    }
  //}
}
// MOVE YOTPO MODULE ON MOBILE
function moveYotpo(){
  if ($(window).width() > 1007) { 
    $("#yotpo-desktop").append($("#yotpo-mobile .yotpo-widget-instance"));
    /*
    if($("#yotpo-mobile").hasClass("active")){
      var content = $("#yotpo-mobile").html();
      $("#yotpo-desktop").html(content).addClass("active");
      $("#yotpo-mobile").empty().removeClass("active"); 
	  //resetYotpo();
    } else {
      var content = $("#yotpo-desktop").html();
      $("#yotpo-mobile").html(content).addClass("active");
      $("#yotpo-desktop").empty().removeClass("active"); 
    }
    */
  } else {
    $("#yotpo-mobile").append($("#yotpo-desktop .yotpo-widget-instance"));

    /*
    if($("#yotpo-desktop").hasClass("active")){
      var content = $("#yotpo-desktop").html();
      $("#yotpo-mobile").html(content).addClass("active");
      $("#yotpo-desktop").empty().removeClass("active"); 
	  //resetYotpo();
    } else {
      var content = $("#yotpo-mobile").html();
      $("#yotpo-desktop").html(content).addClass("active");
      $("#yotpo-mobile").empty().removeClass("active"); 
    }
    */
  }
  /*
  if($('#yotpo-reviews-main-widget').length == 0) {
  	setTimeout(resetYotpo, 150);
  } else {
    resizeYotpo();
  }
  */
}
$(window).resize(function() {
  resizeYotpo();  
  moveYotpo();
});
$(document).ready(function() {
  resizeYotpo();  
  moveYotpo();
});



/*
$( document ).ready(function() {    	
    $('.klaviyo-form-SwHm4j').on('click', 'button', function() {
      event.preventDefault();        
      var email = $(".klaviyo-form-SwHm4j").find("input[name=email]").val();
      var phone = $(".klaviyo-form-SwHm4j").find("input[name=phone-number]").val();
      $("input#klaviyo-email").val(email).trigger("change");
      $("input#klaviyo-phone").val(phone).trigger("change");
      $("#back-in-stock-form-hidden").submit();
    });
    KlaviyoSubscribe.attachToForms('#back-in-stock-form-hidden', {
      success: function(){
        $('.hide-on-success').each(function() {
          $(this).hide();
        });
      },      
      hide_form_on_success: true,
    });
});
*/

$( document ).ready(function() {

/*

/* THIS WORKED BUT TURNED IT OFF */ /*

  $(".Product__Info").on("mouseenter", ".product-specs-link", function(e) {

      if ($(".Product__Info").hasClass('fired') == false) {
        $( ".Product__Info" ).addClass("fired");
        if ($(window).width() > 640) {    

          var block = $(this).attr("data-block");
          $(".product-specs-link").each(function() {
              $(this).removeClass("active");
          }); 
          $(this).addClass("active");

          $(".product-specs-mobile-content").each(function() {
            if($(this).hasClass(block)){
              $(this).slideDown(function() {
                 $( ".Product__Info" ).removeClass("fired");
              });
            } else {
               $(this).slideUp();
            }
          }); 


          	  
        }
      }
  }); 
*/

  /* 
  $(".Product__Info").on({
      mouseenter: function () {
        clearTimeout($(this).data('timeout'));
        if ($(window).width() > 640) {    

              var block = $(this).attr("data-block");
              $(".product-specs-link").each(function() {
                  $(this).removeClass("active");
              }); 
              $(this).addClass("active");

              $(".product-specs-mobile-content").each(function() {
                if($(this).hasClass(block)){
                   $(this).slideDown(function() {
                  });
                } else {
                   $(this).slideUp();
                }
              }); 
        }
      },

      mouseleave: function () {
        var t = setTimeout(function() {
          // DO NOTHING
        }, 5000);
        $(this).data('timeout', t);
      }
  }, '.product-specs-link');
  */
  /*
  $(".Product__Info").on("mouseleave", ".product-specs-link", function() {
    var t = setTimeout(function() {
      // DO NOTHING
    }, 5000);
    $(this).data('timeout', t);
  }); 
  */
}); 


$('.Product__Info').on('click', '.product-specs-link', function() {
//$( ".Product__Tabs .product-specs-link" ).click(function() {
    var block = $(this).attr("data-block");
    if($(this).hasClass("active")){
      $(".product-specs-link").each(function() {
          $(this).removeClass("active");
      }); 
      $(".product-specs-text").each(function() {
          $(this).removeClass("active");
      }); 
      $(".product-specs-mobile-content").each(function() {
          $(this).slideUp();
      }); 
    } else {
      $(".product-specs-link").each(function() {
          $(this).removeClass("active");
      }); 
      $(this).addClass("active");
      $(".product-specs-mobile-content").each(function() {
        if($(this).hasClass(block)){
          $(this).slideDown();
          $(".product-specs-image").each(function() {
              if($(this).hasClass(block)){
                $(this).show();
              }
          }); 
        } else{
          $(this).slideUp();
        }
      });
    }        
}); 


/*
$('.Product__InfoWrapper').on('click', '.yotpo-anchor', function(e) {
	e.preventDefault;  
    if ($(window).width() > 1007){
      $([document.documentElement, document.body]).animate({
        scrollTop: $(".yotpo-desktop").offset().top
      }, 500);
    } else {      
      $([document.documentElement, document.body]).animate({
        scrollTop: $("#yotpo-anchor-mobile").offset().top
      }, 500);
    }
});
*/


/*
// REINITIALIZE SLIDER ON RESIZE
$(window).resize(function() {
	if ($(window).width() < 1007){
      var $carousel = $('.Product__Slideshow').flickity();
      $carousel.resize();
    }
});
*/


/* AJAX COLOR SWATCHES */

  function changeColor(href){

        //var sex = $(this).attr("data-sex");
        //var href = window.location.pathname;
    	//var title = $(this).attr("data-product");
                           
    	// remove variant
        var n = href.indexOf('?');
        href = href.substring(0, n != -1 ? n : href.length);
		//var pagetitle = $(document).prop('title');

    	// MOVE/HIDE BACK IN STOCK FORM
    	//$("#back-in-stock").insertAfter("#product-section").hide();
        $("#mobile-product-description-content").show();

    	//$("#modal-buttons-container").remove();
    	//$(".Product__Tabs").remove();
    
    	//var load = href+" #product-info-content > *";
        var load = href+" #product-info > *";

        // RELOAD FORM
       	//$("#product-info-content").load(load, function(){  
        $("#product-info").load(load, function(){
          
          //$(".loader").remove();
    	  //$("#product-info-content").fadeIn();
          
          // UPDATE JS
          var src = "//goclove.com/cdn/shop/t/808/assets/theme.js?v=16078187783052021631745867513";
          $('script[src="' + src + '"]').remove();
          $('<script>').attr('src', src).appendTo('head');
          
          //$("#product-info").css("height","auto");
          //$("#product-info").css("width","auto");
    	  //$("#product-info-content").fadeIn();
          
          // UNDO-MOVE/HIDE BACK IN STOCK FORM
          //$("#back-in-stock").insertAfter("#product-info .ProductForm");
          //$("#back-in-stock").show();
          
          // UPDATE AFFIRM
          if (typeof affirm !== 'undefined') {
            affirm.ui.refresh();
          }

          // GET AND UPDATE PAGE TITLE AND URL?
          var currenttitle = document.title;
          myArray = currenttitle.split(" ");
          
          var title = $(".colorway-title").text().trim();
          var sex = $(".sex-selected").text().trim();
          title = sex + " " + title + " Shoes | Clove";          
          window.history.pushState('Product', title, href);
          document.title = title;

          selectSize();
          //select_active_option();

       	});    

        // RELOAD IMAGES
        if ($(window).width() > 1007) {
          $("#product-images").fadeTo("fast",0);
          var load = href+" #product-images > *";
          $("#product-images").load(load, function(){
            $("#product-images").fadeTo("fast",1);
          });
          var load = href+" #product-images-mobile > *";
          $("#product-images-mobile").load(load, function(){
            var $carousel = $('.Product__Slideshow').flickity({
              prevNextButtons: true,
              watchCSS: true,
              pageDots: true,
              adaptiveHeight: true  
            });
            $carousel.resize();
          });
        } else {
          $("#product-images-mobile").fadeTo("fast",0);
          var load = href+" #product-images-mobile > *";
          $("#product-images-mobile").load(load, function(){
            var $carousel = $('.Product__Slideshow').flickity({
              prevNextButtons: true,
              watchCSS: true,
              pageDots: true,
              adaptiveHeight: true  
            });
            $carousel.resize();
            $("#product-images-mobile").fadeTo("fast",1);            
          }); 
          var load = href+" #product-images > *";
          $("#product-images").load(load, function(){
          });
        }

        // RELOAD MOBILE HEADER
        //var headerheight = $("#product-mobile-header").height();
        //$("#product-mobile-header").css("height", headerheight);
    	var load = href+" #product-mobile-header > *";
        //$("#product-mobile-header").fadeTo(0);
    	//$("#product-mobile-header").empty();
       	$("#product-mobile-header").load(load, function(){
          //$("#product-mobile-header").css("height", "auto");
          //$("#product-mobile-header").fadeTo(1);
        });
    
        // RELOAD STICKY
    	var load = href+" #header-b #product-sticky > *";
        $("#header-b #product-sticky").empty();
       	$("#header-b #product-sticky").load(load, function(){});
    	var load = href+" #header-e #product-sticky > *";
        $("#header-e #product-sticky").empty();
       	$("#header-e #product-sticky").load(load, function(){});

    	var load = href+" #header-b #product-sticky-b > *";
       	$("#header-b #product-sticky-b").empty();
       	$("#header-b #product-sticky-b").load(load, function(){
          selectSize();
          //select_active_option();
        });
    	var load = href+" #header-e #product-sticky-b > *";
        $("#header-b #product-sticky-c").empty();
       	$("#header-e #product-sticky-b").load(load, function(){
          selectSize();
          //select_active_option();
        });

    
        // RELOAD REVIEWS
    	$("#yotpo-container-desktop").empty();
    	var load = href+" #yotpo-container-desktop > *";
       	$("#yotpo-container-desktop").load(load, function(){  
          // UPDATE YOTPO
          //resetYotpo();
       	});
    	$("#yotpo-container-mobile").empty();
    	var load = href+" #yotpo-container-mobile > *";
       	$("#yotpo-container-mobile").load(load, function(){  
          // UPDATE YOTPO
          resetYotpo();
       	});

        // RELOAD BELOW THE FOLD
    	var load = href+" #product-styles-container > *";
       	$("#product-styles-container").load(load, function(){
            $(window).trigger('resize');
        });
    

  
  }

  $('#shopify-section-product-template').on('click', '.ProductItem__ColorSwatchItem a', function(e) {
    e.preventDefault()
    var href = $(this).attr("href");
    changeColor(href);
  });

/* AUTOSELECT SIZE (use cookie code from nearly new) */

  $( '#main' ).on("click",".SizeSwatch",function (event) {
    var value = $(this).html();
    sessionStorage.setItem("size", value);
  });
  // IS SIZE WAS SELECTED THEN AUTO-SELECT IT
  function selectSize(){
    var sessionsize = sessionStorage.getItem("size");
    if(sessionsize){
      $( '.ProductForm .SizeSwatch' ).each(function() {
        if($(this).html() == sessionsize){
          $(this).trigger("click");
        }
      });
    }
  }
  $( document ).ready(function() {
    selectSize();
  });

// UPDATE SELECTED VARIANT (NEEDED FOR YOTPO)
document.addEventListener('variant:changed', function(e) {
  var data = e.detail.variant;
  if(data){
    ShopifyAnalytics.meta.selectedVariantId = data.id;
    var jsonAttn = JSON.parse($('#attn-meta-data').html());
    //alert(jsonAttn);
    //alert(ShopifyAnalytics.meta.product.variants);
    ShopifyAnalytics.meta.product.variants = jsonAttn;   

  }
});


document.querySelectorAll(".ProductItem__ColorSwatchItem").forEach(productSwatch => {
    const observerTarget = productSwatch;
    if (observerTarget.querySelector("a")) {
        observerTarget.querySelector("a").setAttribute('aria-label', observerTarget.querySelector("label").getAttribute("data-tooltip"));
    }
    const config = {
        subtree: true,
        attributeOldValue: true,
        attributes: true
    };
    const callback = (mutationList) => {
        for (const mutation of mutationList) {
            if (mutation.type === "attributes") {
                const target = mutation.target;
                const label = target.querySelector("label");
                let name = ''
                if (label) {
                  name = label.getAttribute("data-tooltip");
                }
                if (mutation.target.classList.contains("soldout")) {
                  label.setAttribute("data-tooltip", `${name} - Unavailable`);
                  target.querySelector("a").setAttribute('aria-label', `${name} - Unavailable`)
                } else if (mutation.oldValue && mutation.oldValue.includes("soldout")) {
                  label.setAttribute("data-tooltip", `${name.replace(" - Unavailable","")}`);
                  target.querySelector("a").setAttribute('aria-label', `${name.replace(" - Unavailable","")}`)
                }

            }
        }
    };
    const observer = new MutationObserver(callback);
    observer.observe(observerTarget, config);
})

